export default function() {
  Backbone.Stickit.addHandler([
    {
      selector: '.js-start-date, .js-end-date',
      events: ['change'],
      update($el, val) {
        if (val) {
          $el.datepicker('setDate', val);
        } else {
          $el.datepicker('setDate', '');
        }
      },
    },
  ]);
}



// WEBPACK FOOTER //
// ./js/backbone/utilities/add_daterange_picker_stickit_handler.js